import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { updateRoom } from '../../redux/currentSearch/actions';
import { NonPrimeHotelPropsDefault, DpPaxRestrictionPropsDefault } from '../../models';
import { CurrentAccommodationSearchSessionStorage } from '../../utils';

export const useVerifyHotelRooms = (rooms, isNonPrimeHotel) => {
    const dispatch = useDispatch();
    const maxAge = isNonPrimeHotel ? NonPrimeHotelPropsDefault.maxKidsAge : DpPaxRestrictionPropsDefault.maxKidsAge;

    if (rooms?.[0]?.kids?.length) {
        const validKids = rooms[0].kids.filter((k) => k <= maxAge);
        if (validKids.length !== rooms[0].kids.length) {
            dispatch(
                updateRoom({ ...rooms[0], kids: validKids })
            );
            CurrentAccommodationSearchSessionStorage.setRooms({ ...rooms[0], kids: validKids });
        }
    }
};

useVerifyHotelRooms.propTypes = {
    rooms: PropTypes.array.isRequired,
    isNonPrimeHotel: PropTypes.bool.isRequired,
};

useVerifyHotelRooms.defaultProps = {
    isNonPrimeHotel: false,
};
